// API client para Reporte de Seguros de Estudiantes
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Reporte de Seguros de Estudiantes.
 *
 * El backend determina automáticamente los estudiantes con inscripción
 * ACTIVA (INSCRITO/PREINSCRITO) en los ciclos vigentes a la fecha actual,
 * reutilizando la misma fuente de verdad que los flujos de Inscripción
 * de Nuevo Ingreso y Reinscripción (tabla esc_inscripciones).
 *
 * @param {Object} params
 * @param {number|string} [params.id_campus]
 * @param {number|string} [params.id_seccion]
 * @param {number|string} [params.id_programa]
 */
export async function getReporteSegurosEstudiantes(params = {}) {
  const { id_campus, id_seccion, id_programa } = params;

  const qs = new URLSearchParams();
  if (id_campus && id_campus !== 'todos') qs.set('id_campus', id_campus);
  if (id_seccion && id_seccion !== 'todos') qs.set('id_seccion', id_seccion);
  if (id_programa && id_programa !== 'todos') qs.set('id_programa', id_programa);
  qs.set('_t', String(Date.now()));

  const res = await fetch(`${API_BASE}/escolar/reportes/seguros-estudiantes/?${qs.toString()}`, {
    headers: getAuthHeaders(),
    cache: 'no-store',
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`GET /reportes/seguros-estudiantes/ ${res.status}: ${text}`);
  }
  return res.json();
}

export default getReporteSegurosEstudiantes;
